// @ts-nocheck
// Store Sync - ProductListProductInformation

import { VariantDisplayTypeValues, VariantTraitModel } from "@insite/client-framework/Types/ApiModels";

const getVariantDisplayTrait = (variantTraits: VariantTraitModel[]) => {
    let variantDisplayTrait = null;
    if (variantTraits && variantTraits.length > 0) {
        const swatchedViewList = [
            VariantDisplayTypeValues.SwatchDropdown,
            VariantDisplayTypeValues.SwatchList,
            VariantDisplayTypeValues.SwatchGrid,
        ];
        const sortedVaraintTraits = variantTraits.slice().sort((a, b) => a.sortOrder - b.sortOrder);
        variantDisplayTrait = sortedVaraintTraits.find(x => swatchedViewList.includes(x.displayType));
    }

    return variantDisplayTrait;
};

export default getVariantDisplayTrait;
